module.exports = __webpack_public_path__ + "img/79_35.25bcc2cf.png";